// @flow
import React, { Component, Fragment } from "react";

import type { ErrorsType } from "../../types/UserFormType";
import { ErrosDisplay, setErrorMsg } from "../../containers/ErrosDisplay";
import LicenceDevices from "../../components/licences/LicenceDevices";
import {
  GeneralModalForm,
  DeleteButton,
  ConfirmCancelDialog
} from "imagus-components";
import AssignLicenceForm from "../../components/licences/AssignLicenceForm";
import AssignEmailNotificationForm from "../../components/licences/AssignEmailNotificationForm";
import CreateLicenceFormRedux from "../../containers/licences/CreateLicenceFormRedux";
import LicenceItemTable from "./LicenceItemTable";
import LicenceHistories from "./LicenceHistories";

import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import AddAlarmIcon from "@material-ui/icons/AddAlarm";
import EmailIcon from "@material-ui/icons/Email";
import EditIcon from "@material-ui/icons/Edit";
import HistoryIcon from "@material-ui/icons/History";

type LicenceItemPropsType = {
  licence: { [key: string]: * },
  company: { [key: string]: * },
  isAdmin?: boolean,
  displayCompany?: boolean,
  isLicenceAdmin: boolean,
  isImagusAdmin: boolean,
  canEdit?: boolean,
  openSnackbar?: Function,
  assignDevice: Function,
  unAssignDevice: Function,
  downloadLicence: Function,
  downloadPOFile: Function,
  deleteLicence: Function,
  deleteLicenceHistory: Function,
  emailNotification?: ?{
    emailList: Array<string>,
    days: number,
    isNotified: boolean,
    uuid?: string
  },
  onEmailNotificationSubmit?: Function,
  removeLicenceEmailNotification?: Function
};

type LicenceItemStatesType = {
  errors: ErrorsType,
  isLoading: boolean,
  editModal: boolean,
  addDeviceModal: boolean,
  deleteDialog: boolean,
  historyModal: boolean
};

class LicenceItem extends Component<
  LicenceItemPropsType,
  LicenceItemStatesType
> {
  constructor(props: LicenceItemPropsType) {
    super(props);
    this.state = {
      errors: {},
      isLoading: false,
      editModal: false,
      addDeviceModal: false,
      addEmailNotificationModal: false,
      deleteDialog: false,
      historyModal: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  setActionError = (errors: ErrorsType): * => {
    this.setState({
      errors: errors
    });
  };

  downloadFile = (licenceExtentId?: string): * => (): * => {
    this.props.downloadPOFile(
      this.props.licence.id,
      licenceExtentId,
      (url: string): * => window.open(url),
      this.setActionError
    );
  };

  render(): * {
    const licence = this.props.licence;
    const displayAssignButton = licence.slotsAvail > 0 && licence.expiryMinutes > 0 && this.props.canEdit;
    const displayEmailNotificationButton = this.props.licence.licenceType === "EVALUATION" || this.props.licence.licenceType === "ONEYEAR";

    return (
      <div>
        <div className="top-banner">
          <ErrosDisplay errors={this.state.errors} form="user" />
        </div>
        <div className="app-panel-content panel-top-margin">
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <Typography variant="h6" style={{ display: "inline-flex" }}>
                Licence Summary
              </Typography>
              {this.props.isImagusAdmin && this.props.canEdit && (
                <span>
                  {licence.histories.length > 0 && (
                    <Fragment>
                      <IconButton
                        aria-label="History"
                        onClick={(): * =>
                          this.switchModalStatus("historyModal")(true)
                        }
                      >
                        <HistoryIcon className="shine-icon" />
                      </IconButton>
                      <GeneralModalForm
                        title="Licence History"
                        open={this.state.historyModal}
                        handleModalStatus={this.switchModalStatus(
                          "historyModal"
                        )}
                        maxMd
                        form={
                          <LicenceHistories
                            onClose={(): * =>
                              this.switchModalStatus("historyModal")(false)
                            }
                            histories={licence.histories}
                            downloadFile={this.downloadFile}
                            deleteLicenceHistory={
                              this.props.deleteLicenceHistory
                            }
                            setActionError={this.setActionError}
                          />
                        }
                      />
                    </Fragment>
                  )}
                  <IconButton
                    aria-label="Edit"
                    onClick={(): * => this.switchModalStatus("editModal")(true)}
                  >
                    <EditIcon className="shine-icon" />
                  </IconButton>
                  <GeneralModalForm
                    title="Edit Licence"
                    open={this.state.editModal}
                    handleModalStatus={this.switchModalStatus("editModal")}
                    form={
                      <CreateLicenceFormRedux
                        onClose={(): * =>
                          this.switchModalStatus("editModal")(false)
                        }
                        company={this.props.company}
                        facebases={[]}
                        openSnackbar={this.props.openSnackbar}
                        isEdit
                        isAdmin={this.props.isAdmin}
                        displayCompany={this.props.displayCompany}
                        licence={licence}
                      />
                    }
                  />
                  <DeleteButton
                    loading={this.state.isLoading}
                    onClick={(): * =>
                      this.switchModalStatus("deleteDialog")(true)
                    }
                  />
                  <ConfirmCancelDialog
                    open={this.state.deleteDialog}
                    handleModalStatus={this.switchModalStatus("deleteDialog")}
                    deleteFunction={(): * => {
                      this.setState({ isLoading: true });
                      this.props.deleteLicence &&
                        this.props.deleteLicence(
                          licence.id,
                          licence.uuid,
                          (): * =>
                            this.props.openSnackbar &&
                            this.props.openSnackbar(6),
                          this.setActionError
                        );
                    }}
                    itemName={licence.facebaseName}
                  />
                </span>
              )}
            </Grid>
            <Grid item xs={12} md={10}>
              <LicenceItemTable
                licence={licence}
                isAdmin={this.props.isAdmin}
                displayCompany={this.props.displayCompany}
                isLicenceAdmin={this.props.isLicenceAdmin}
                isImagusAdmin={this.props.isImagusAdmin}
                downloadFile={this.downloadFile}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {displayAssignButton && (
                  <div style={{ lineHeight: "58px" }}>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      className="dark-btn"
                      onClick={(): * =>
                        this.switchModalStatus("addDeviceModal")(true)
                      }
                    >
                      <AddAlarmIcon className="light-icon right-margin-5" />
                      Assign Device
                    </Button>
                    <GeneralModalForm
                      title="Assign Licence"
                      open={this.state.addDeviceModal}
                      handleModalStatus={this.switchModalStatus("addDeviceModal")}
                      form={
                        <AssignLicenceForm
                          onClose={(): * =>
                            this.switchModalStatus("addDeviceModal")(false)
                          }
                          licenceId={licence.id}
                          licenceUuid={licence.uuid}
                          assignDevice={this.props.assignDevice}
                        />
                      }
                    />
                  </div>
                )}
                {displayEmailNotificationButton && this.props.isImagusAdmin && (
                  <div style={{ lineHeight: "58px" }}>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      className="dark-btn"
                      onClick={(): * =>
                        this.switchModalStatus("addEmailNotificationModal")(true)
                      }
                    >
                      <EmailIcon className="light-icon right-margin-5" />
                      Email Notification
                    </Button>
                    <GeneralModalForm
                      title="Email Notification"
                      open={this.state.addEmailNotificationModal}
                      handleModalStatus={this.switchModalStatus("addEmailNotificationModal")}
                      form={
                        <AssignEmailNotificationForm
                          onClose={(): * =>
                            this.switchModalStatus("addEmailNotificationModal")(false)
                          }
                          licenceId={licence.uuid}
                          emailList={this.props.emailNotification ? this.props.emailNotification.email_list : []}
                          days={this.props.emailNotification ? this.props.emailNotification.days : 0}
                          isNotified={this.props.emailNotification ? this.props.emailNotification.is_notified : false}
                          notificationUuid={this.props.emailNotification ? this.props.emailNotification.uuid : undefined}
                          onSubmit={this.props.onEmailNotificationSubmit}
                          onDelete={this.props.emailNotification && this.props.emailNotification.uuid
                            ? (uuid: string) => {
                              this.props.removeLicenceEmailNotification(uuid);
                              this.switchModalStatus("addEmailNotificationModal")(false);
                            }
                            : undefined}
                        />
                      }
                    />
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </div>
        <LicenceDevices
          devices={licence.devices}
          facebaseUuid={licence.facebaseUuid}
          isExpired={licence.expiryMinutes < 0 || this.props.canEdit !== true}
          licenceId={licence.id}
          licenceUuid={licence.uuid}
          setActionError={this.setActionError}
          unAssignDevice={this.props.unAssignDevice}
          downloadLicence={this.props.downloadLicence}
          isImagusAdmin={this.props.isImagusAdmin}
        />
      </div>
    );
  }
}

export default LicenceItem;
